import React from 'react';
import ReactDOM from 'react-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import Box from '@material-ui/core/Box';

import CustomCard from './components/card-item/card-item';

const App = () => {

	const cardData = [
		{ title: 'gk-dust-bunny-1', cpUrl: 'https://codepen.io/kapustiansky/pen/jOMNbOm', cardClass: 'gk-dust-bunny-1', id: '1'},
		{ title: 'gk-dust-bunny-2', cpUrl: 'https://codepen.io/kapustiansky/pen/WNGeQeR', cardClass: 'gk-dust-bunny-2', id: '2'},
		{ title: 'gk-dust-bunny-s', cpUrl: 'https://codepen.io/kapustiansky/pen/zYBgLmV', cardClass: 'gk-dust-bunny-s', id: '3'},
		{ title: 'gk-totoro-1', cpUrl: 'https://codepen.io/kapustiansky/pen/WNGevqo', cardClass: 'gk-totoro-1', id: '4'},
		{ title: 'gk-totoro-2', cpUrl: 'https://codepen.io/kapustiansky/pen/KKgPpOm', cardClass: 'gk-totoro-2', id: '5'},
		{ title: 'gk-darth-vader', cpUrl: 'https://codepen.io/kapustiansky/pen/MWjWyZb', cardClass: 'gk-darth-vader', id: '6'},
		{ title: 'gk-r2d2', cpUrl: 'https://codepen.io/kapustiansky/pen/rNMNeRw', cardClass: 'gk-r2d2', id: '7'},
		{ title: 'gk-groot', cpUrl: 'https://codepen.io/kapustiansky/pen/YzGzqMd', cardClass: 'gk-groot', id: '8'},
		{ title: 'gk-iron-man', cpUrl: 'https://codepen.io/kapustiansky/pen/zYKYqgp', cardClass: 'gk-iron-man', id: '9'},
		{ title: 'gk-spiderman', cpUrl: 'https://codepen.io/kapustiansky/pen/RwGwRbO', cardClass: 'gk-spiderman', id: '10'},
		{ title: 'gk-avengers', cpUrl: 'https://codepen.io/kapustiansky/pen/RwGwRNm', cardClass: 'gk-avengers', id: '11'},
		{ title: 'gk-tic-tac-toe', cpUrl: 'https://codepen.io/kapustiansky/pen/rNMNLOY', cardClass: 'gk-tic-tac-toe', id: '12'},
		{ title: 'gk-vulcan-salute', cpUrl: 'https://codepen.io/kapustiansky/pen/ZEpEOQX', cardClass: 'gk-vulcan-salute', id: '13'},
		{ title: 'gk-harry-potter', cpUrl: 'https://codepen.io/kapustiansky/pen/MWjWeyv', cardClass: 'gk-harry-potter', id: '14'},
		{ title: 'gk-bond-007', cpUrl: 'https://codepen.io/kapustiansky/pen/PoGozzw', cardClass: 'gk-bond-007', id: '15'},
		{ title: 'gk-minions', cpUrl: 'https://codepen.io/kapustiansky/pen/xxExOOJ', cardClass: 'gk-minions', id: '16'},
		{ title: 'gk-psyduck', cpUrl: 'https://codepen.io/kapustiansky/pen/QWKWEKG', cardClass: 'gk-psyduck', id: '17'}
	];

  return	(
		<Box p={2}>
			<CssBaseline />
			<CustomCard cards={cardData} />
		</Box>
    );
  }

ReactDOM.render(<App />, document.getElementById('root'));
